<template>
  <div class="items-center flex">
    <div class="flex items-center px-16 py-12 rounded-16px justify-center">
      <div class="w-full">
        <div class="w-full">
          <div class="flex items-center gap-4 ml-4">
            <img src="@/assets/images/BA 5.png" alt="image" class="w-24" />
            <h2
              class="lg:font-semibold md:font-semibold font-bold lg:text-3xl md:text-2xl text-xl"
            >
              Lastly, would you like to have custom functionalities?
            </h2>
          </div>
        </div>

        <div class="w-full flex justify-end mt-10">
          <div class="w-11/12 mr-5">
            <div
              class="shadow rounded-lg cursor-pointer w-full relative"
              v-for="(item, index) in cards"
              :key="'item_' + index"
              :class="{
                'bg-primary  text-white': item.selectStatus
                  ? item.selectStatus
                  : false,
              }"
              @click="selected(item)"
            >
              <div class="flex items-center shadow rounded-lg p-4 mb-4">
                <p class="fsize16 sm-fsize14 p-2 font-semibold ml-4">
                  {{ item.title }}
                </p>
              </div>
              <div
                class="absolute top-0 right-0 customMargin"
                v-if="!item.plans.includes(selectedPlan.plan.name)"
              >
                <img
                  src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/scopeRequirements/crown2.png"
                  alt="image"
                  class="w-25px"
                />
              </div>
            </div>
          </div>
          <!-- <p class="lg:w-3/5 md:w-3/5 fsize18 sm-fsize14 mt-8">
              Perhaps a new ecommerce moghoul in the making? Tell us the
              industry your business belongs to.
            </p> -->
        </div>
      </div>
      <el-dialog
        :visible.sync="upgradePlanPopup"
        width="30%"
        class="el-header-hide rounded-lg dialogcustomclass"
        :class="[
          upgradePlans.length == 2
            ? 'planspopup600'
            : upgradePlans.length == 3
            ? 'planspopup900'
            : upgradePlans.length == 4
            ? 'planspopup1100'
            : 'planspopup415',
        ]"
      >
        <div class="lg:p-4">
          <div class="flex justify-between">
            <div>
              <h2 class="font-semibold fsize20">Select Plan</h2>
              <p class="text-gray fsize14 pt-1">
                Please select your preferable subscription plan
              </p>
            </div>

            <feather-icon
              @click="Popupclose"
              icon="XIcon"
              class="cursor-pointer"
            />
          </div>
          <div
            v-if="upgradePlans.length"
            class="lg:grid md:grid flex gap-4 mt-8 role overflow-x-auto"
            :class="[
              upgradePlans.length == 2
                ? 'grid-cols-2'
                : upgradePlans.length == 3
                ? 'grid-cols-3'
                : upgradePlans.length == 4
                ? 'grid-cols-4'
                : 'grid-cols-1',
            ]"
          >
            <div
              class="bg-white shadow-md p-2 rounded-2xl wid-300px h-96 relative"
              v-for="plan in upgradePlans"
              :key="plan._id"
            >
              <div class="wid-280px">
                <div
                  class="px-5 py-8 rounded-2xl customroundbrdr"
                  :class="[
                    plan.name == 'Business'
                      ? 'bg-primary'
                      : plan.name == 'Essential'
                      ? 'bgprimary-light'
                      : 'col-ed',
                  ]"
                >
                  <div class="flex gap-4" v-if="plan.name != 'Business'">
                    <img
                      v-if="['Free', 'Starter'].includes(plan.name)"
                      class="w-5 h-5"
                      src="@/assets/images/new-log/dworld.png"
                      alt="white8"
                    />
                    <img
                      v-if="plan.name == 'Essential'"
                      class="w-5 h-5"
                      src="@/assets/images/new-log/white.png"
                      alt="white"
                    />
                  </div>
                  <div v-if="plan.name == 'Business'" class="flex gap-2">
                    <img
                      class="w-5 h-5 apps-gl object-contain"
                      :src="require('@/assets/images/Ecommerce.png')"
                      alt="white"
                    />
                    <img
                      class="w-5 h-5 object-contain apps-glr"
                      :src="require('@/assets/images/andriod.png')"
                      alt="white2"
                    />
                    <img
                      class="w-5 h-5 object-contain"
                      :src="require('@/assets/images/ios.png')"
                      alt="white3"
                    />
                  </div>
                  <h1
                    class="fsize20 mt-2 font-semibold"
                    :class="[
                      plan.name == 'Business'
                        ? 'text-white'
                        : plan.name == 'Essential'
                        ? 'text-white'
                        : 'text-393939',
                    ]"
                  >
                    {{ plan.name }} <br />subscription
                  </h1>
                </div>

                <div class="flex mt-5 justify-center">
                  <div class="w-full h270px">
                    <div
                      class="planswitch text-center justify-center 0 mb-4 mt-4"
                    >
                      <h2 class="text-dark font-bold fsize18">
                        {{ plan.sgPrice }}
                        <span class="fsize12"> / Monthly </span>
                      </h2>
                    </div>
                    <div class="y-scroll">
                      <div
                        class="grid grid-cols-1 gap-2 text-left mt-3"
                        v-for="(feature, index) in plan.features"
                        :key="'feature' + index"
                      >
                        <p
                          class="font-semibold fsize12 text-center text-424242"
                          :class="{
                            'text-primary': feature.status,
                            'text-grey': !feature.status,
                          }"
                        >
                          {{ feature.text }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-12 items-end flex btnfix">
                <button
                  class="w-full cursor-pointer col-ed border-none rounded-12px fsize14 font-semibold py-4"
                  @click="selectPlan(plan)"
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      upgradePlans: [],
      upgradePlanPopup: false,

      cards: [
        {
          id: 1,
          selectStatus: false,
          title: "No, I’m fine with standard functionalities.",
          type: "Free",
          plans: [
            "Free",
            "Starter",
            "Essential",
            "Prototype",
            "Business",
            "Enterprise",
          ],
        },
        {
          id: 2,
          selectStatus: false,
          title: "Yes, I want to have some custom features in my project.",
          type: "Business",
          plans: ["Business", "Enterprise"],
        },
      ],
      selectedItem: "",
    };
  },
  methods: {
    async selectPlan(plan) {
      const selectedPlanDetails = {
        plan: plan,
        billing: !plan.selected ? plan.plans[0] : plan.plans[1],
      };
      this.$store.commit("scope/SET_PLAN", selectedPlanDetails);
      this.selected(this.selectedItem);
    },
    Popupclose() {
      this.upgradePlanPopup = false;
    },
    selected(item) {
      this.selectedItem = item;
      if (!item.plans.includes(this.selectedPlan.plan.name)) {
        this.upgradePlans = [];
        this.upgradePlans.push(this.plans[4]);
        for (let index = 0; index < this.upgradePlans.length; index++) {
          if (this.upgradePlans[index].name == "Starter")
            this.upgradePlans[index].sgPrice = "S$19";
          if (this.upgradePlans[index].name == "Prototype")
            this.upgradePlans[index].sgPrice = "S$89";
          if (this.upgradePlans[index].name == "Essential")
            this.upgradePlans[index].sgPrice = "S$399";
          if (this.upgradePlans[index].name == "Business")
            this.upgradePlans[index].sgPrice = "S$1599";
        }
        this.upgradePlanPopup = true;
      } else {
        this.$store.commit("scope/REPLACE_Suites_Question", item);
        this.Popupclose();
      }
      this.refresh();
    },
    refresh() {
      for (let index = 0; index < this.cards.length; index++) {
        if (this.cards[index].title == this.selectedSuitesQuestion[0].title) {
          this.cards[index].selectStatus = true;
        } else {
          this.cards[index].selectStatus = false;
        }
      }
    },
  },
  async mounted() {
    this.$store.commit("scope/SET_CURRENT_PAGE", "pageSuiteQuestion");
    await this.$store.commit("scope/REPLACE_Suites_Question", this.cards[0]);
    this.refresh();
  },
  computed: {
    ...mapState("scope", ["selectedPlan", "selectedSuitesQuestion", "plans"]),
  },
};
</script>
<style>
.input-effect {
  border: 0;
  padding: 7px 0;
  border-bottom: 3px solid #ccc;
}

.input-effect ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #ff92d5;
  transition: 0.4s;
}
.input-effect:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}
.input-effect ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #ff92d5;
  transition: 0.4s;
}
.input-effect:focus ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}
.y-scroll {
  overflow-y: auto;
  height: 165px;
}
.y-scroll::-webkit-scrollbar {
  width: 5px;
  background-color: #f1f1f1;
  height: 5px;
}

/* Handle */
.y-scroll::-webkit-scrollbar-thumb {
  background: rgba(var(--vs-primary), 0.5) !important;
  border-radius: 0px 0px 4px 4px;
}
.dialogcustomclass .el-dialog {
  border-radius: 15px !important;
}
.customroundbrdr {
  border-radius: 15px !important;
}
</style>
